import React from 'react';
import { Globe, Layers, Database, Box } from 'lucide-react';
import { useCases } from '../mock';

const iconMap = { Globe, Layers, Database, Box };

export const UseCases = () => {
  return (
    <section className="py-16 md:py-32 bg-[#0A0E14] relative overflow-hidden">
      <div className="absolute inset-0 pro-grid opacity-30"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-12 md:mb-20">
          <div className="inline-block mb-3 md:mb-4">
            <span className="text-green-400 text-[10px] md:text-xs font-semibold uppercase tracking-wider">Use Cases</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 px-4">
            Built for <span className="text-green-400">Every Workload</span>
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-400 max-w-3xl mx-auto px-4">
            From startups to enterprise, deploy with confidence
          </p>
        </div>

        {/* Use Cases Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {useCases.map((useCase, index) => {
            const Icon = iconMap[useCase.icon];
            return (
              <div
                key={useCase.id}
                className="group"
                style={{ animation: 'fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards', animationDelay: `${index * 100}ms`, opacity: 0 }}
              >
                <div className="glass-card rounded-xl p-6 md:p-8 h-full hover:border-green-500/20 transition-all duration-300">
                  <div className="w-10 h-10 md:w-12 md:h-12 mb-4 md:mb-5 bg-green-500/10 rounded-lg flex items-center justify-center group-hover:bg-green-500/15 transition-colors duration-300">
                    <Icon className="text-green-400" size={20} />
                  </div>
                  
                  <h3 className="text-lg md:text-xl font-bold text-white mb-2 md:mb-3">
                    {useCase.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {useCase.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};